import {
  GET_WIP_AI_CONVERSATION,
  LIST_WIP_AI_CONVERSATIONS,
  GENERATE_WIP_AI_REVISION,
  SEND_WIP_AI_MESSAGE,
  SUBMIT_WIP_AI_REVISION,
  RESTORE_WIP_AI_REVISION,
  DISCARD_WIP_AI_PROPOSAL,
  GET_WIP_AI_STAFF_UTILIZATION,
} from './query'

export const getWipAiConversation = async (client, projectId, month) => {
  const { data } = await client.query({
    query: GET_WIP_AI_CONVERSATION,
    variables: { projectId, month },
    fetchPolicy: 'no-cache',
  })
  return data.getWipAiConversation
}

export const listWipAiConversations = async (client, projectId) => {
  const { data } = await client.query({
    query: LIST_WIP_AI_CONVERSATIONS,
    variables: { projectId },
    fetchPolicy: 'no-cache',
  })
  return data.listWipAiConversations
}

export const generateWipAiRevision = async (client, projectId, month) => {
  const { data } = await client.mutate({
    mutation: GENERATE_WIP_AI_REVISION,
    variables: { projectId, month },
  })
  return data.generateWipAiRevision
}

export const sendWipAiMessage = async (client, projectId, month, text) => {
  const { data } = await client.mutate({
    mutation: SEND_WIP_AI_MESSAGE,
    variables: { projectId, month, text },
  })
  return data.sendWipAiMessage
}

export const submitWipAiRevision = async (client, projectId, month, messageId) => {
  const { data } = await client.mutate({
    mutation: SUBMIT_WIP_AI_REVISION,
    variables: { projectId, month, messageId },
  })
  return data.submitWipAiRevision
}

export const restoreWipAiRevision = async (client, revisionId) => {
  const { data } = await client.mutate({
    mutation: RESTORE_WIP_AI_REVISION,
    variables: { revisionId },
  })
  return data.restoreWipAiRevision
}

export const discardWipAiProposal = async (client, projectId, month, messageId) => {
  const { data } = await client.mutate({
    mutation: DISCARD_WIP_AI_PROPOSAL,
    variables: { projectId, month, messageId },
  })
  return data.discardWipAiProposal
}

export const getWipAiStaffUtilization = async (client, projectId, month) => {
  const { data } = await client.query({
    query: GET_WIP_AI_STAFF_UTILIZATION,
    variables: { projectId, month },
    fetchPolicy: 'no-cache',
  })
  return data.getWipAiStaffUtilization
}
